import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import React from "react";
import { Link, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import GameDetails from "./components/GameDetails";
import Home from "./components/Home";
import "./styles.css";

import GridViewIcon from "@mui/icons-material/GridView";
import ViewListIcon from "@mui/icons-material/ViewList";
import {
  Box,
  createTheme,
  CssBaseline,
  IconButton,
  ThemeProvider,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";

import InfoIcon from '@mui/icons-material/Info';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import { useState } from "react";
import About from "./components/About";

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [view, setView] = useState("list"); 
  const lightTheme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#3f51b5",
      },
      background: {
        default: "#ffffff",
        paper: "#f4f6f8",
      },
    },
  });

  const darkTheme = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#90caf9",
      },
      background: {
        default: "#121212",
        paper: "#1e1e1e",
      },
    },
  });

  const handleToggleDarkMode = () => {
    setDarkMode((prevMode) => !prevMode);
  };
  const handleViewChange = (event, nextView) => {
    setView(nextView);
  };
  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <CssBaseline />
      <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <ToggleButtonGroup
            value={darkMode ? "dark" : "light"}
            exclusive
            onChange={handleToggleDarkMode}
            aria-label="mode toggle"
          >
            <ToggleButton value="dark" aria-label="dark mode">
              <DarkModeIcon />
            </ToggleButton>
            <ToggleButton value="light" aria-label="light mode">
              <LightModeIcon />
            </ToggleButton>
          </ToggleButtonGroup>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
            <Link to="/" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <SportsEsportsIcon sx={{ fontSize: 80, color: 'primary.main' }} />
            </Link>
            <IconButton component={Link} to="/about" color="inherit" size="small" aria-label="about">
              <InfoIcon />
            </IconButton>
          </Box>
          <ToggleButtonGroup
            value={view === "grid" ? "grid" : "list"}
            exclusive
            onChange={handleViewChange}
            aria-label="view toggle"
          >
            <ToggleButton value="grid" aria-label="grid view">
              <ViewListIcon />
            </ToggleButton>
            <ToggleButton value="list" aria-label="list view">
              <GridViewIcon />
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        <Routes>
          <Route path="/" element={<Home darkMode={darkMode} view={view} />} />
          <Route
            path="/game/:id"
            element={<GameDetails darkMode={darkMode} />}
          />
          <Route path="/about" element={<About />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
